import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";
import { useLocale } from "../../i18n/LocaleContext";

const FAQS = [
  { q: "Is OMNISupply a marketplace or a managed aggregator?", a: "Managed aggregator. Infosys is the single Vendor of Record on your contract, sitting between you and a 30M+ SKU catalog sourced from global OEMs, manufacturers and tier-one distributors — absorbing supplier orchestration, expediting and consolidated invoicing so you transact with one entity." },
  { q: "How is OMNISupply different from a standard PunchOut catalog?", a: "PunchOut is the delivery mechanism, not the value. OMNISupply combines a 30M+ SKU catalog, master commercial terms, ESG-curated supply base and Infosys-operated SRM behind it. You get savings, governance and operational simplification — not just a shopping experience." },
  { q: "Which procurement platforms do you integrate with?", a: "SAP Ariba, Coupa, Oracle iProcurement, Jaggaer, ServiceNow and Workday Procurement are pre-certified for PunchOut. For deep integration, we support SAP S/4HANA, Oracle Fusion and Microsoft Dynamics with bi-directional PO, ASN, GRN and invoice flows." },
  { q: "How quickly can we go live?", a: "Typical timeline is 8–12 weeks for PunchOut, 12–16 weeks for embedded Search API and 16–24 weeks for deep ERP integration — depending on number of business units, geographies and category waves." },
  { q: "How are commercials structured?", a: "Infosys monetizes through aggregator margins embedded in catalog pricing, alongside an annual platform subscription fee that may apply based on your committed annual spend. Customers receive a transparent rate card by category, with savings consistently reported at the basket level rather than at the individual SKU level — ensuring commercial visibility without exposing line-item OEM economics. Category-level savings dashboards are published quarterly as part of the governance review." },
  { q: "Will this affect our preferred local suppliers?", a: "No — strategic local suppliers are retained or onboarded into the OMNISupply network. The consolidation targets the long tail of 15,000–23,000 low-value, fragmented suppliers that drain procurement operations." },
  { q: "Is this offered globally?", a: "Yes. UniBuy™ launches with coverage across 80+ countries via our global OEM, manufacturer and distributor network. Regional category depth varies and is reviewed during the discovery phase." },
];

export default function FAQ() {
  const { t } = useLocale();
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="bg-slate-50 py-24 md:py-32 border-y border-slate-200"
    >
      <div className="max-w-4xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-3 text-[11px] uppercase tracking-[0.22em] text-slate-500 font-semibold mb-4">
            <span className="inline-block h-px w-8 bg-slate-300" />
            <span>{t("landing.faq.eyebrow")}</span>
            <span className="inline-block h-px w-8 bg-slate-300" />
          </div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl xl:text-[56px] font-semibold tracking-[-0.02em] mt-1 text-slate-900 leading-[1.05]">
            {t("landing.faq.headline")}
          </h2>
        </div>

        <Accordion type="single" collapsible className="space-y-3">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="rounded-xl border border-slate-200 bg-white px-5 md:px-6"
            >
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="text-left font-display text-base md:text-lg font-semibold text-slate-900 hover:no-underline py-5"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-slate-600 leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
